export default "__VITE_ASSET__a06d4817__"